import { GetterTree } from 'vuex'
import { TemplatesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<TemplatesState, RootState> = {
    customTemplates:state => state.customTemplates,
    customMultichannelTemplates:state => state.customMultichannelTemplates,
    customTemplateItem:state => state.customTemplateItem,
};
